module.exports = __webpack_public_path__ + "img/t1-i2.d47d7496.jpg";